import { basename } from "../Url";
import Cookies from "js-cookie";

export const axiosConfig = {
  baseURL: basename + "/api/v1/",
  timeout: 100000,
  headers: {
    "X-CSRFToken": Cookies.get("csrftoken"),
    "Content-Type": "application/json"
  },
  withCredentials: true
};

export const axiosUpdateFileConfig = {
  baseURL: basename + "/api/v1/",
  timeout: 0,
  headers: {
    "X-CSRFToken": Cookies.get("csrftoken"),
    "X-Requested-With": "XMLHttpRequest"
  },
  withCredentials: true
};
